(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ajax-cart-drawer"]) return;
  try {
    
  /**
   * Cart Drawer — Drop Zone AJAX Cart
   *
   * Handles open/close, AJAX cart operations (fetch API),
   * quantity debouncing, focus trapping, and accessibility.
   */
  (function CartDrawerInit() {
    const SELECTORS = {
      drawer: '#cart-drawer',
      backdrop: '[data-cart-backdrop]',
      closeBtn: '[data-cart-close]',
      body: '[data-cart-body]',
      items: '[data-cart-items]',
      footer: '[data-cart-footer]',
      empty: '[data-cart-empty]',
      progress: '[data-cart-progress]',
      subtotal: '[data-cart-subtotal]',
      cartCount: '[data-cart-count]',
      liveRegion: '[data-cart-live-region]',
      headerCart: '.header__cart',
      headerCartCount: '.header__cart-count',
      headerCartBadge: '.header__cart-badge',
    };

    const DEBOUNCE_MS = 300;
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    let drawer, backdrop, debounceTimers = {};
    let triggerElement = null;

    function init() {
      drawer = document.querySelector(SELECTORS.drawer);
      backdrop = document.querySelector(SELECTORS.backdrop);

      if (!drawer || !backdrop) return;

      /* Close buttons */
      drawer.querySelectorAll(SELECTORS.closeBtn).forEach(btn => {
        btn.addEventListener('click', close);
      });
      backdrop.addEventListener('click', close);

      /* Escape key */
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen()) close();
      });

      /* Header cart icon → open drawer instead of navigating */
      const headerCart = document.querySelector(SELECTORS.headerCart);
      if (headerCart) {
        headerCart.addEventListener('click', (e) => {
          e.preventDefault();
          triggerElement = headerCart;
          open();
        });
      }

      /* Listen for cart:open custom event (from add-to-cart forms) */
      document.addEventListener('cart:open', (e) => {
        triggerElement = e.detail?.trigger || null;
        open();
      });

      /* Silent refresh on add — keeps the badge + drawer contents current
         without opening it (the toast handles the notification instead). */
      document.addEventListener('cart:added', () => { fetchAndRender(); });

      /* Delegate line item actions */
      drawer.addEventListener('click', handleItemAction);
      drawer.addEventListener('change', handleQuantityChange);
    }

    /* =====================================================
       Open / Close
       ===================================================== */

    function isOpen() {
      return drawer.classList.contains('is-open');
    }

    function open() {
      /* Refresh cart state before opening */
      fetchAndRender().then(() => {
        drawer.hidden = false;
        backdrop.hidden = false;

        /* Force reflow before adding class for transition */
        void drawer.offsetHeight;

        drawer.classList.add('is-open');
        backdrop.classList.add('is-active');
        document.body.classList.add('cart-drawer-open');

        /* Focus first close button */
        const closeBtn = drawer.querySelector(SELECTORS.closeBtn);
        if (closeBtn) closeBtn.focus();

        /* Trap focus */
        drawer.addEventListener('keydown', trapFocus);

        /* No cart_viewed publish here: the Google & YouTube sales channel owns
           the standard ecommerce funnel, and we run no custom Web Pixels. */
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-active');
      document.body.classList.remove('cart-drawer-open');

      drawer.removeEventListener('keydown', trapFocus);

      /* Return focus to trigger */
      if (triggerElement) {
        triggerElement.focus();
        triggerElement = null;
      }

      /* Hide after transition */
      const onEnd = () => {
        if (!isOpen()) {
          drawer.hidden = true;
          backdrop.hidden = true;
        }
        drawer.removeEventListener('transitionend', onEnd);
      };
      drawer.addEventListener('transitionend', onEnd);

      /* Fallback for prefers-reduced-motion */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        drawer.hidden = true;
        backdrop.hidden = true;
      }
    }

    /* =====================================================
       Focus Trap
       ===================================================== */

    function trapFocus(e) {
      if (e.key !== 'Tab') return;

      const focusable = [...drawer.querySelectorAll(FOCUSABLE)].filter(
        el => el.offsetParent !== null
      );
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    /* =====================================================
       AJAX Cart Operations
       ===================================================== */

    function handleItemAction(e) {
      const btn = e.target.closest('[data-action]');
      if (!btn) return;

      const item = btn.closest('.cart-drawer__item');
      if (!item) return;

      const line = parseInt(item.dataset.line, 10);
      const input = item.querySelector('[data-action="quantity"]');
      const currentQty = input ? parseInt(input.value, 10) : 1;
      const action = btn.dataset.action;

      if (action === 'decrease') {
        const newQty = Math.max(0, currentQty - 1);
        if (input) input.value = newQty;
        debouncedUpdate(line, newQty);
      } else if (action === 'increase') {
        const newQty = currentQty + 1;
        if (input) input.value = newQty;
        debouncedUpdate(line, newQty);
      } else if (action === 'remove') {
        updateCartLine(line, 0);
      }
    }

    function handleQuantityChange(e) {
      if (!e.target.matches('[data-action="quantity"]')) return;

      const item = e.target.closest('.cart-drawer__item');
      if (!item) return;

      const line = parseInt(item.dataset.line, 10);
      const newQty = Math.max(0, parseInt(e.target.value, 10) || 0);
      debouncedUpdate(line, newQty);
    }

    function debouncedUpdate(line, quantity) {
      if (debounceTimers[line]) clearTimeout(debounceTimers[line]);
      debounceTimers[line] = setTimeout(() => {
        updateCartLine(line, quantity);
        delete debounceTimers[line];
      }, DEBOUNCE_MS);
    }

    function updateCartLine(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(res => res.json())
        .then(() => fetchAndRender())
        .catch(err => console.error('[Cart Drawer] Update error:', err));
    }

    /* =====================================================
       Fetch & Re-render
       ===================================================== */

    function fetchAndRender() {
      /* Resolve THIS section's Section Rendering API id from its own Shopify
         wrapper (#shopify-section-<id>). The previous lookup fell back to the
         first [data-section-id] on the page — an unrelated section (the header) —
         so the fetched HTML never contained the cart body and the drawer
         silently failed to re-render. Most visible when removing the last line:
         the row persisted until a page reload. */
      const wrapper = drawer.closest('.shopify-section');
      const sectionId = (wrapper && wrapper.id)
        ? wrapper.id.replace(/^shopify-section-/, '')
        : 'ajax-cart-drawer';

      return fetch(`${window.location.pathname}?sections=${sectionId}`)
        .then(res => res.json())
        .then(sections => {
          const html = sections[sectionId];
          if (!html) return fetchFallback();

          const temp = document.createElement('div');
          temp.innerHTML = html;

          /* Replace body content */
          const newBody = temp.querySelector(SELECTORS.body);
          const currentBody = drawer.querySelector(SELECTORS.body);
          if (newBody && currentBody) currentBody.innerHTML = newBody.innerHTML;

          /* Replace footer */
          const newFooter = temp.querySelector(SELECTORS.footer);
          const currentFooter = drawer.querySelector(SELECTORS.footer);
          if (newFooter && currentFooter) {
            currentFooter.innerHTML = newFooter.innerHTML;
          } else if (newFooter && !currentFooter) {
            drawer.appendChild(newFooter.cloneNode(true));
          } else if (!newFooter && currentFooter) {
            currentFooter.remove();
          }

          /* Replace count in heading */
          const newCount = temp.querySelector(SELECTORS.cartCount);
          const currentCount = drawer.querySelector(SELECTORS.cartCount);
          if (newCount && currentCount) currentCount.textContent = newCount.textContent;

          /* Update header cart badge */
          updateHeaderCartCount(temp);
        })
        .catch(() => fetchFallback());
    }

    function fetchFallback() {
      return fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          updateHeaderBadge(cart.item_count);
          announce(cart.item_count + ' items in cart');
        });
    }

    function updateHeaderCartCount(tempDom) {
      /* Extract item count from the new DOM */
      const newCountEl = tempDom.querySelector(SELECTORS.cartCount);
      const match = newCountEl?.textContent.match(/\d+/);
      const count = match ? parseInt(match[0], 10) : 0;

      updateHeaderBadge(count);
      announce(count > 0 ? count + ' items in cart' : 'Cart is empty');
    }

    function updateHeaderBadge(count) {
      const headerCountWrap = document.querySelector(SELECTORS.headerCartCount);
      if (!headerCountWrap) return;

      if (count > 0) {
        headerCountWrap.innerHTML =
          '<span class="header__cart-badge">' + count + '</span>' +
          '<span class="visually-hidden">' + count + ' items in cart</span>';
      } else {
        headerCountWrap.innerHTML = '';
      }
    }

    function announce(message) {
      const region = document.querySelector(SELECTORS.liveRegion);
      if (region) region.textContent = message;
    }

    /* =====================================================
       Boot
       ===================================================== */

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tiles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      var track = root.querySelector('[data-ct-track]');
      var dotsEl = root.querySelector('[data-ct-dots]');
      if (!track || !dotsEl) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function pageCount() {
        var items = track.children;
        if (!items.length) return 1;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var tileW = items[0].getBoundingClientRect().width;
        var per = Math.max(1, Math.round((track.clientWidth + gap) / (tileW + gap)));
        return Math.ceil(items.length / per);
      }

      function currentPage() {
        if (track.clientWidth === 0) return 0;
        return Math.round(track.scrollLeft / track.clientWidth);
      }

      function setActive(idx) {
        var dots = dotsEl.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
        }
      }

      function build() {
        var pages = pageCount();
        dotsEl.textContent = '';
        if (pages <= 1) return; // fits one row → centered, no navigation
        for (var i = 0; i < pages; i++) {
          (function (page) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'collection-tiles__dot';
            b.setAttribute('aria-label', 'Go to category page ' + (page + 1));
            b.setAttribute('aria-current', page === 0 ? 'true' : 'false');
            b.addEventListener('click', function () {
              track.scrollTo({ left: page * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
            });
            dotsEl.appendChild(b);
          })(i);
        }
        setActive(currentPage());
      }

      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(currentPage()); });
      });

      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(build, 150);
      });

      build();
    }

    function init() {
      document.querySelectorAll('[data-ct-carousel]').forEach(initCarousel);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var section = document.querySelector('.collection');
    if (!section) return;

    var filterForm = section.querySelector('#collection-filters');
    var sortSelect = section.querySelector('#collection-sort');
    var main = section.querySelector('.collection__main');

    var collectionUrl = section.getAttribute('data-collection-url');
    var sectionId = section.getAttribute('data-section-id');
    var collectionId = section.getAttribute('data-collection-id');
    var collectionTitle = section.getAttribute('data-collection-title');

    /* ---- Mobile drawer (delegated so it survives filter re-renders) ---- */
    function openDrawer() {
      section.classList.add('collection--filters-open');
      var b = section.querySelector('[data-filter-open]');
      if (b) b.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeDrawer() {
      section.classList.remove('collection--filters-open');
      var b = section.querySelector('[data-filter-open]');
      if (b) b.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }
    section.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-open]')) { openDrawer(); }
      else if (e.target.closest('[data-filter-close]')) { closeDrawer(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    var supportsAjax = !!(collectionUrl && sectionId && window.fetch &&
      window.AbortController && window.DOMParser && window.URLSearchParams);

    /* ---- Fallback for very old browsers: original full-page submit ---- */
    if (!supportsAjax) {
      if (filterForm) {
        filterForm.addEventListener('change', function () {
          if (window.matchMedia('(min-width: 1025px)').matches) filterForm.submit();
        });
      }
      return;
    }

    /* ==================================================================
       AJAX faceted filtering — Section Rendering API, address bar untouched
       ================================================================== */
    var controller = null;
    var debounceTimer = null;

    /* Move parsed (inert) nodes across instead of innerHTML — CSP/hook-safe */
    function replaceInner(target, source) {
      if (!target || !source) return;
      while (target.firstChild) target.removeChild(target.firstChild);
      while (source.firstChild) target.appendChild(source.firstChild);
    }

    function setLoading(on) {
      if (!main) return;
      main.classList.toggle('is-loading', on);
      main.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    /* Current filter state lives in the form (+ sort select), never the URL */
    function getParams() {
      var params = new URLSearchParams();
      if (filterForm) {
        new FormData(filterForm).forEach(function (value, key) {
          if (value !== '' && value != null) params.append(key, value);
        });
      }
      if (sortSelect && sortSelect.value) {
        params.delete('sort_by');
        params.append('sort_by', sortSelect.value);
      }
      return params;
    }

    function readProducts() {
      try {
        var node = section.querySelector('[data-collection-products]');
        return node ? JSON.parse(node.textContent || '[]') : [];
      } catch (e) { return []; }
    }

    function dispatchUpdated(trigger, paramsStr) {
      section.dispatchEvent(new CustomEvent('collection:updated', {
        bubbles: true,
        detail: {
          trigger: trigger || 'load',
          params: paramsStr || '',
          collection: { id: collectionId, title: collectionTitle },
          products: readProducts()
        }
      }));
      if (trigger === 'filter') {
        section.dispatchEvent(new CustomEvent('filter:changed', {
          bubbles: true, detail: { params: paramsStr || '' }
        }));
      }
    }

    function restoreFocus(name, val) {
      if (!name) return;
      try {
        var esc = (window.CSS && CSS.escape) ? CSS.escape : function (s) { return s; };
        var sel = '[name="' + esc(name) + '"]' + (val ? '[value="' + esc(val) + '"]' : '');
        var el = filterForm.querySelector(sel);
        if (el) el.focus();
      } catch (e) {}
    }

    function swap(doc, opts) {
      opts = opts || {};
      var freshResults = doc.querySelector('[data-results]');
      var freshFilters = doc.querySelector('#collection-filters');
      var freshCount = doc.querySelector('.collection__count');
      var freshToggle = doc.querySelector('.collection__filter-toggle');

      var results = section.querySelector('[data-results]');
      if (results && freshResults) replaceInner(results, freshResults);

      if (filterForm && freshFilters) {
        var active = document.activeElement;
        var inForm = active && filterForm.contains(active);
        var name = inForm ? active.name : null;
        var val = inForm ? active.value : null;
        var scroll = filterForm.scrollTop;
        replaceInner(filterForm, freshFilters);
        filterForm.scrollTop = scroll; /* keep the sticky sidebar's scroll position */
        restoreFocus(name, val);
      }

      var count = section.querySelector('.collection__count');
      if (count && freshCount) count.textContent = freshCount.textContent;

      /* Active-filter chips beside the totals */
      var chips = section.querySelector('[data-active]');
      var freshChips = doc.querySelector('[data-active]');
      if (chips && freshChips) {
        replaceInner(chips, freshChips);
        chips.hidden = chips.childElementCount === 0; /* keep it out of flow when empty */
      }

      var toggle = section.querySelector('.collection__filter-toggle');
      if (toggle && freshToggle) replaceInner(toggle, freshToggle); /* refresh the mobile count badge */

      if (opts.scrollTop) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function render(url, opts) {
      opts = opts || {};
      if (controller) controller.abort();
      controller = new AbortController();

      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);

      setLoading(true);
      fetch(u.toString(), { signal: controller.signal })
        .then(function (r) { if (!r.ok) throw new Error('bad response'); return r.text(); })
        .then(function (html) {
          swap(new DOMParser().parseFromString(html, 'text/html'), opts);
          setLoading(false);
          var visible = new URLSearchParams(u.search);
          visible.delete('section_id');
          dispatchUpdated(opts.trigger, visible.toString());
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return; /* superseded — ignore */
          setLoading(false);
          window.location.assign(url); /* never leave the user stuck */
        });
    }

    function applyForm(opts) {
      opts = opts || {};
      opts.trigger = opts.trigger || 'filter';
      render(collectionUrl + '?' + getParams().toString(), opts);
    }

    /* ---- Filter chips, clear links, pagination (delegated) ---- */
    section.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link || !section.contains(link)) return;
      if (link.closest('.product-card')) return; /* product links navigate normally */

      var href = link.getAttribute('href') || '';
      var isFilterNav =
        link.matches('.active-filter') ||
        !!link.closest('.collection__empty') ||
        !!link.closest('.pagination') ||
        /[?&](filter\.|page=|sort_by=)/.test(href);
      if (!isFilterNav) return;

      e.preventDefault();

      if (/[?&]page=/.test(link.href)) {
        /* Pagination links carry no filter params (URL is clean) — merge current
           form state with the requested page so filters survive paging. */
        var page = new URL(link.href, window.location.origin).searchParams.get('page') || '1';
        var p = getParams();
        p.set('page', page);
        render(collectionUrl + '?' + p.toString(), { trigger: 'page', scrollTop: true });
      } else {
        /* Chip removal / clear links already encode the correct target state */
        render(link.href, { trigger: 'filter' });
      }
    });

    /* ---- Form + sort triggers ---- */
    if (filterForm) {
      filterForm.addEventListener('change', function () {
        if (window.matchMedia('(min-width: 1025px)').matches) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () { applyForm(); }, 250);
        }
        /* mobile/tablet: batched behind the Apply button */
      });
      filterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        clearTimeout(debounceTimer);
        closeDrawer(); /* close first so the spinner shows on the grid, not behind the drawer */
        applyForm();
      });
    }
    if (sortSelect) {
      sortSelect.removeAttribute('onchange'); /* JS owns sort now (no full submit) */
      sortSelect.addEventListener('change', function () { applyForm({ trigger: 'sort' }); });
    }

    /* Initial view_item_list */
    dispatchUpdated('load', new URLSearchParams(window.location.search).toString());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-consent"]) return;
  try {
    
  (function() {
    'use strict';

    var CONSENT_COOKIE = 'dz_consent';
    var CONSENT_EXPIRY_DAYS = 365;

    var banner = document.getElementById('cookie-consent-banner');
    if (!banner) return;

    var reopenTab = document.querySelector('[data-consent-reopen]');

    /* Detect Shopify preview bar and offset cookie banner above it */
    var previewBar = document.getElementById('PBarNextFrameWrapper');
    if (previewBar) {
      var barHeight = previewBar.offsetHeight || 68;
      banner.style.setProperty('--preview-bar-offset', barHeight + 'px');
    }

    var consentVersion = banner.getAttribute('data-consent-version') || '1.0';

    /* -------------------------------------------------------
       Consent cookie helpers
       ------------------------------------------------------- */

    /* Read the cookie only. May be missing even after a successful save:
       Safari's ITP caps the lifetime of cookies written via document.cookie to
       7 days (24 hours when the visitor arrived from a cross-site navigation,
       e.g. an Instagram or Google Ads link), and blocks the write outright when
       the storefront is framed — as it is in the Shopify theme preview. */
    function readCookie() {
      var parts = document.cookie ? document.cookie.split('; ') : [];
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf(CONSENT_COOKIE + '=') === 0) {
          try {
            return JSON.parse(decodeURIComponent(parts[i].slice(CONSENT_COOKIE.length + 1)));
          } catch (e) {
            return null;
          }
        }
      }
      return null;
    }

    /* Web Storage is not subject to the ITP cookie-lifetime cap, and survives
       in framed/preview contexts where cookie writes are dropped. Every access
       is guarded: Safari throws on storage in some lockdown configurations. */
    function readStorage(store) {
      try {
        var raw = window[store] && window[store].getItem(CONSENT_COOKIE);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    /* First store that has a usable record wins. sessionStorage is checked
       first so a dismissal always sticks for the rest of the visit, even if
       every persistent write was blocked. */
    function getConsent() {
      return readStorage('sessionStorage') || readStorage('localStorage') || readCookie();
    }

    function setConsent(prefs) {
      var data = {
        necessary: true,
        analytics: !!prefs.analytics,
        marketing: !!prefs.marketing,
        timestamp: new Date().toISOString(),
        version: consentVersion
      };

      var json = JSON.stringify(data);
      try { window.sessionStorage.setItem(CONSENT_COOKIE, json); } catch (e) {}
      try { window.localStorage.setItem(CONSENT_COOKIE, json); } catch (e) {}

      var value = encodeURIComponent(json);
      var expires = new Date(Date.now() + CONSENT_EXPIRY_DAYS * 864e5).toUTCString();
      /* Secure would make the cookie a no-op over plain http (local dev) */
      var secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = CONSENT_COOKIE + '=' + value
        + '; expires=' + expires
        + '; path=/; SameSite=Lax' + secure;

      /* Sync with Shopify Customer Privacy API */
      if (window.Shopify && window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: prefs.analytics,
          marketing: prefs.marketing,
          preferences: true,
          sale_of_data: false
        }, function() {});
      }

      /* Dispatch custom event for other scripts to react */
      document.dispatchEvent(new CustomEvent('consentUpdated', { detail: data }));
    }

    function hasValidConsent() {
      var consent = getConsent();
      if (!consent) return false;

      /* Check version match */
      if (consent.version !== consentVersion) return false;

      /* Check 12-month expiry */
      var consentDate = new Date(consent.timestamp);
      var twelveMonthsAgo = new Date(Date.now() - 365 * 864e5);
      return consentDate > twelveMonthsAgo;
    }

    /* -------------------------------------------------------
       Banner show / hide
       ------------------------------------------------------- */

    function showTab() { if (reopenTab) reopenTab.hidden = false; }
    function hideTab() { if (reopenTab) reopenTab.hidden = true; }

    /* Reflect the stored choice in the preference checkboxes (used on reopen) */
    function syncCheckboxes() {
      var consent = getConsent();
      var a = banner.querySelector('input[name="analytics"]');
      var m = banner.querySelector('input[name="marketing"]');
      if (a) a.checked = !!(consent && consent.analytics);
      if (m) m.checked = !!(consent && consent.marketing);
    }

    function showBanner() {
      banner.style.display = '';
      hideTab();
    }

    function hideBanner() {
      banner.style.display = 'none';
      /* Close preferences panel if open */
      var panel = banner.querySelector('.cookie-banner__preferences');
      var manageBtn = banner.querySelector('[data-consent-action="manage"]');
      if (panel) {
        panel.setAttribute('hidden', '');
        panel.classList.remove('is-open');
      }
      if (manageBtn) {
        manageBtn.setAttribute('aria-expanded', 'false');
      }
      showTab();
    }

    /* -------------------------------------------------------
       Action handlers
       ------------------------------------------------------- */

    function handleAcceptAll() {
      setConsent({ analytics: true, marketing: true });
      hideBanner();
    }

    function handleReject() {
      setConsent({ analytics: false, marketing: false });
      hideBanner();
    }

    function handleManage() {
      var panel = banner.querySelector('.cookie-banner__preferences');
      var manageBtn = banner.querySelector('[data-consent-action="manage"]');
      if (!panel) return;

      var isHidden = panel.hasAttribute('hidden');
      if (isHidden) {
        panel.removeAttribute('hidden');
        /* Trigger reflow so the transition runs */
        panel.offsetHeight;
        panel.classList.add('is-open');
        if (manageBtn) manageBtn.setAttribute('aria-expanded', 'true');
      } else {
        panel.classList.remove('is-open');
        panel.setAttribute('hidden', '');
        if (manageBtn) manageBtn.setAttribute('aria-expanded', 'false');
      }
    }

    function handleSavePreferences() {
      var analyticsCheckbox = banner.querySelector('input[name="analytics"]');
      var marketingCheckbox = banner.querySelector('input[name="marketing"]');
      setConsent({
        analytics: analyticsCheckbox ? analyticsCheckbox.checked : false,
        marketing: marketingCheckbox ? marketingCheckbox.checked : false
      });
      hideBanner();
    }

    /* -------------------------------------------------------
       Event delegation
       ------------------------------------------------------- */

    banner.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-consent-action]');
      if (!btn) return;

      var action = btn.getAttribute('data-consent-action');
      switch (action) {
        case 'accept-all':
          handleAcceptAll();
          break;
        case 'reject':
          handleReject();
          break;
        case 'manage':
          handleManage();
          break;
        case 'save-preferences':
          handleSavePreferences();
          break;
      }
    });

    /* Reopen tab: bring the banner back with the preferences panel open */
    if (reopenTab) {
      reopenTab.addEventListener('click', function() {
        syncCheckboxes();
        showBanner();
        handleManage(); /* panel is closed after any hide, so this opens it */
        var firstToggle = banner.querySelector('.cookie-banner__preferences input:not([disabled])');
        if (firstToggle) firstToggle.focus();
      });
    }

    /* -------------------------------------------------------
       Init: banner if no valid consent, otherwise the reopen tab
       ------------------------------------------------------- */

    if (!hasValidConsent()) {
      showBanner();
    } else {
      showTab();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    /* =====================================================================
       1. Mobile drawer — Focus trap + Escape + Scroll-lock
       ===================================================================== */
    var details = document.getElementById('mobile-menu');
    if (details) {
      var drawer = details.querySelector('.header__drawer');
      var closeBtn = details.querySelector('.header__drawer-close');
      var focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      var trapHandler = null;

      function getFocusableElements() {
        if (!drawer) return [];
        return Array.prototype.slice.call(drawer.querySelectorAll(focusableSelectors));
      }

      function handleTrapKeydown(e) {
        if (e.key === 'Escape') {
          details.removeAttribute('open');
          return;
        }
        if (e.key !== 'Tab') return;

        var focusable = getFocusableElements();
        if (focusable.length === 0) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      details.addEventListener('toggle', function() {
        if (details.open) {
          document.body.classList.add('scroll-lock');
          trapHandler = handleTrapKeydown;
          document.addEventListener('keydown', trapHandler);
          if (closeBtn) {
            closeBtn.focus();
          }
        } else {
          document.body.classList.remove('scroll-lock');
          if (trapHandler) {
            document.removeEventListener('keydown', trapHandler);
            trapHandler = null;
          }
          var summary = details.querySelector('summary');
          if (summary) {
            summary.focus();
          }
        }
      });

      /* --- Mobile nested menu toggles --- */
      var drawerToggles = details.querySelectorAll('[data-drawer-toggle]');
      for (var i = 0; i < drawerToggles.length; i++) {
        (function(toggle) {
          toggle.addEventListener('click', function() {
            var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

            var submenu = toggle.parentElement.querySelector('.header__drawer-submenu');
            if (submenu) {
              if (isExpanded) {
                submenu.classList.remove('header__drawer-submenu--visible');
              } else {
                submenu.classList.add('header__drawer-submenu--visible');
              }
            }
          });
        })(drawerToggles[i]);
      }
    }

    /* =====================================================================
       2. Desktop mega-menu toggle
       ===================================================================== */
    var header = document.querySelector('.header');
    if (!header) return;

    var triggers = header.querySelectorAll('.header__nav-trigger');
    var activeTrigger = null;

    function closeAllMegaMenus() {
      for (var i = 0; i < triggers.length; i++) {
        triggers[i].setAttribute('aria-expanded', 'false');
      }
      activeTrigger = null;
    }

    function openMegaMenu(trigger) {
      /* Close any currently open mega-menu first */
      closeAllMegaMenus();
      trigger.setAttribute('aria-expanded', 'true');
      activeTrigger = trigger;
    }

    for (var i = 0; i < triggers.length; i++) {
      (function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
          if (isExpanded) {
            closeAllMegaMenus();
          } else {
            openMegaMenu(trigger);
          }
        });
      })(triggers[i]);
    }

    /* Close on Escape */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && activeTrigger) {
        var returnFocus = activeTrigger;
        closeAllMegaMenus();
        returnFocus.focus();
      }
    });

    /* Close on click outside */
    document.addEventListener('click', function(e) {
      if (!activeTrigger) return;
      if (!e.target.closest('.header__nav-item')) {
        closeAllMegaMenus();
      }
    });

    /* =====================================================================
       3. Sticky header — collapse announcement bar on scroll
       =====================================================================
       Collapsing the announcement bar shrinks the sticky header's box in
       normal flow, which shrinks total document height. At a single scroll
       threshold the browser's scroll-anchoring would nudge scrollY back across
       that threshold, re-expand the bar, and oscillate — the flicker/jump loop.

       Fix: a hysteresis dead-band. Collapse only once scrolled well past the
       bar (COLLAPSE_AT), restore only when back near the very top (RESTORE_AT).
       The gap between the two MUST exceed the announcement bar height (~2.5rem
       / 40px) so an anchoring nudge can never carry scrollY across the opposite
       threshold. State is latched so the class only flips on a real crossing. */
    if (header.classList.contains('header--sticky')) {
      var COLLAPSE_AT = 64; /* px scrolled before the announcement bar hides */
      var RESTORE_AT = 4;   /* px — restore only when back at the very top */
      var scrolled = false;
      var ticking = false;

      var evaluateHeader = function() {
        ticking = false;
        var y = window.scrollY;
        if (!scrolled && y > COLLAPSE_AT) {
          scrolled = true;
          header.classList.add('header--scrolled');
        } else if (scrolled && y < RESTORE_AT) {
          scrolled = false;
          header.classList.remove('header--scrolled');
        }
      };

      var onHeaderScroll = function() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(evaluateHeader);
        }
      };

      window.addEventListener('scroll', onHeaderScroll, { passive: true });
      evaluateHeader();
    }

    /* =====================================================================
       5. Wishlist header badge count
       ===================================================================== */
    function updateWishlistBadge(count) {
      var el = document.querySelector('[data-wishlist-header-count]');
      if (!el) return;
      if (count > 0) {
        el.innerHTML = '<span class="header__wishlist-badge">' + count + '</span>';
      } else {
        el.innerHTML = '';
      }
    }

    document.addEventListener('wishlist:changed', function(e) {
      updateWishlistBadge(e.detail.count);
    });

    /* Initial count from localStorage */
    try {
      var stored = localStorage.getItem('dz_wishlist');
      if (stored) {
        var items = JSON.parse(stored);
        updateWishlistBadge(items.length);
      }
    } catch (e) { /* silent */ }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-product-recs]');
    if (!el || el.children.length) return; // already populated server-side
    var url = el.getAttribute('data-recs-url');
    if (!url) return;

    function load() {
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-product-recs]');
          if (!fresh) return;
          var container = fresh.querySelector('.container');
          if (!container) return; // no related products found
          el.textContent = '';
          el.appendChild(container); // DOMParser is inert; move nodes (no innerHTML)
        })
        .catch(function () {});
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { obs.unobserve(e.target); load(); }
        });
      }, { rootMargin: '0px 0px 300px 0px' });
      io.observe(el);
    } else {
      load();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    /* ===== Gallery carousel: swipe + arrows + dots (mobile), thumbnails (desktop) ===== */
    var gallery = document.querySelector('[data-gallery]');
    var galleryTrack = gallery ? gallery.querySelector('[data-slides]') : null;
    var slides = galleryTrack ? Array.prototype.slice.call(galleryTrack.children) : [];
    var thumbnails = Array.prototype.slice.call(document.querySelectorAll('.product__thumbnail'));
    var dotsEl = gallery ? gallery.querySelector('[data-dots]') : null;
    var galleryReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function galleryGoTo(i) {
      if (!galleryTrack || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      galleryTrack.scrollTo({ left: i * galleryTrack.clientWidth, behavior: galleryReduce ? 'auto' : 'smooth' });
    }
    function galleryCurrent() {
      if (!galleryTrack || !galleryTrack.clientWidth) return 0;
      return Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth);
    }
    function gallerySetActive(i) {
      thumbnails.forEach(function(t, j) {
        t.classList.toggle('product__thumbnail--active', j === i);
        t.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      if (dotsEl) {
        Array.prototype.slice.call(dotsEl.children).forEach(function(d, j) {
          d.setAttribute('aria-current', j === i ? 'true' : 'false');
        });
      }
    }

    if (gallery && slides.length) {
      if (dotsEl) {
        slides.forEach(function(_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'product__dot';
          b.setAttribute('aria-label', 'Go to image ' + (i + 1));
          b.addEventListener('click', function() { galleryGoTo(i); });
          dotsEl.appendChild(b);
        });
      }
      var galleryPrev = gallery.querySelector('[data-gallery-prev]');
      var galleryNext = gallery.querySelector('[data-gallery-next]');
      if (galleryPrev) galleryPrev.addEventListener('click', function() { galleryGoTo(galleryCurrent() - 1); });
      if (galleryNext) galleryNext.addEventListener('click', function() { galleryGoTo(galleryCurrent() + 1); });
      thumbnails.forEach(function(t, i) {
        t.addEventListener('click', function() { galleryGoTo(i); });
      });
      var galleryRaf;
      galleryTrack.addEventListener('scroll', function() {
        if (galleryRaf) cancelAnimationFrame(galleryRaf);
        galleryRaf = requestAnimationFrame(function() { gallerySetActive(galleryCurrent()); });
      });
      gallerySetActive(0);
    }

    /* Variant option change → update hidden variant id */
    var optionInputs = document.querySelectorAll('.product__option input[type="radio"]');
    var variantIdInputs = document.querySelectorAll('input[name="id"]');
    var productJson = null;

    try {
      var productDataEl = document.querySelector('[data-product-json]');
      if (productDataEl) {
        productJson = JSON.parse(productDataEl.textContent);
      }
    } catch(e) {}

    /**
     * Collect the currently-selected value for every option fieldset.
     * Returns an array like ['Red', 'M'] matching option1, option2, etc.
     */
    function getSelectedOptions() {
      var selected = [];
      document.querySelectorAll('.product__option').forEach(function(fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) {
          selected.push(checked.value);
        }
      });
      return selected;
    }

    /**
     * Find the variant whose option1/option2/option3 values match the
     * currently-selected options array.
     */
    function findVariant(selectedOptions) {
      if (!productJson) return null;
      for (var i = 0; i < productJson.length; i++) {
        var v = productJson[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v['option' + (j + 1)] !== selectedOptions[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    /**
     * Format a Shopify price integer (cents) into "R1 234.00" display string.
     */
    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return 'R' + parts.join('.');
    }

    /**
     * Update all price-display elements on the page for the given variant.
     */
    function updatePrice(variant) {
      var priceDisplays = document.querySelectorAll('.price-display');
      if (!variant) return;

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      priceDisplays.forEach(function(el) {
        if (onSale) {
          el.innerHTML =
            '<span class="visually-hidden">Regular price</span>' +
            '<s class="price price--compare">' + formatMoney(variant.compare_at_price) + '</s>' +
            '<span class="visually-hidden">Sale price</span>' +
            '<span class="price price--on-sale">' + formatMoney(variant.price) + '</span>';
        } else {
          el.innerHTML =
            '<span class="price">' + formatMoney(variant.price) + '</span>';
        }
      });
    }

    /**
     * Update add-to-cart button text and disabled state for both the
     * desktop form and the sticky mobile bar.
     */
    function updateAddToCartButtons(variant) {
      var buttons = document.querySelectorAll('[type="submit"].btn--primary');
      buttons.forEach(function(btn) {
        var label = btn.querySelector('[data-atc-label]') || btn;
        if (!variant) {
          btn.disabled = true;
          label.textContent = 'Unavailable';
        } else if (!variant.available) {
          btn.disabled = true;
          label.textContent = 'Sold out';
        } else {
          btn.disabled = false;
          label.textContent = 'Add to cart';
        }
      });
    }

    /**
     * Swap the main product image to the variant's featured image.
     * Also update the active thumbnail to match.
     */
    function updateProductImage(variant) {
      if (!variant || !variant.featured_image) return;
      var targetId = String(variant.featured_image.id);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-image-id') === targetId) {
          galleryGoTo(i);
          return;
        }
      }
    }

    /**
     * Announce variant change to screen readers via the aria-live region.
     */
    function announceVariantChange(variant) {
      var statusEl = document.getElementById('product-variant-status');
      if (!statusEl) return;
      if (!variant) {
        statusEl.textContent = 'Selected variant is unavailable.';
      } else if (!variant.available) {
        statusEl.textContent = variant.title + ', sold out.';
      } else {
        statusEl.textContent = variant.title + ', ' + formatMoney(variant.price) + '.';
      }
    }

    optionInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        /* Update swatch visual state */
        var fieldset = input.closest('.product__option');
        fieldset.querySelectorAll('.product__swatch').forEach(function(s) {
          s.classList.remove('product__swatch--selected');
        });
        input.closest('.product__swatch').classList.add('product__swatch--selected');

        /* Find the matching variant and update the page */
        var selectedOptions = getSelectedOptions();
        var variant = findVariant(selectedOptions);

        /* Update hidden variant ID inputs (main form + sticky mobile form) */
        variantIdInputs.forEach(function(idInput) {
          idInput.value = variant ? variant.id : '';
          idInput.disabled = !variant;
        });

        updatePrice(variant);
        updateAddToCartButtons(variant);
        updateProductImage(variant);
        announceVariantChange(variant);
      });
    });

    /* Quantity stepper */
    document.querySelectorAll('.product__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.closest('.product__quantity-stepper').querySelector('.product__qty-input');
        var val = parseInt(input.value) || 1;
        var change = parseInt(btn.dataset.qtyChange) || 0;
        var newVal = Math.max(1, val + change);
        input.value = newVal;
      });
    });
  })();

  /* ===== AJAX Add-to-Cart ===== */
  (function() {
    /* Target all product forms on this page (desktop + sticky mobile) */
    var forms = document.querySelectorAll('form[action="/cart/add"]');

    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var submitBtn = form.querySelector('[type="submit"]');
        if (!submitBtn || submitBtn.disabled) return;

        /* Disable button and show loading state */
        var atcLabel = submitBtn.querySelector('[data-atc-label]') || submitBtn;
        var originalText = atcLabel.textContent;
        submitBtn.disabled = true;
        atcLabel.textContent = 'Adding…';

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(res) {
          if (!res.ok) {
            /* 422 = sold out / over stock limit; surface as an error, not success. */
            return res.json().then(function(data) {
              throw new Error((data && data.description) || 'Could not add to cart');
            });
          }
          return res.json();
        })
        .then(function(item) {
          /* Restore button with confirmation */
          atcLabel.textContent = 'Added ✓';
          setTimeout(function() {
            submitBtn.disabled = false;
            atcLabel.textContent = originalText;
          }, 1500);

          /* Notify: refresh cart badge + show the added-to-bag toast */
          document.dispatchEvent(new CustomEvent('cart:added', {
            detail: { item: item, trigger: submitBtn }
          }));
        })
        .catch(function(err) {
          console.error('[Product] Add-to-cart error:', err);
          submitBtn.disabled = false;
          atcLabel.textContent = originalText;
        });
      });
    });
  })();

  /* ===== Description "Read more" (clamps long copy; full text stays in DOM) ===== */
  (function () {
    var wrap = document.querySelector('[data-description]');
    if (!wrap) return;
    var body = wrap.querySelector('[data-description-body]');
    var toggle = wrap.querySelector('[data-description-toggle]');
    if (!body || !toggle) return;
    var moreEl = toggle.querySelector('[data-description-more]');
    var lessEl = toggle.querySelector('[data-description-less]');

    wrap.classList.add('is-clamped');
    requestAnimationFrame(function () {
      if (body.scrollHeight > body.clientHeight + 4) {
        toggle.hidden = false;
      } else {
        wrap.classList.remove('is-clamped');
      }
    });

    toggle.addEventListener('click', function () {
      var clamped = wrap.classList.toggle('is-clamped');
      toggle.setAttribute('aria-expanded', String(!clamped));
      if (moreEl) moreEl.hidden = !clamped;
      if (lessEl) lessEl.hidden = clamped;
    });
  })();

  /* ===== Secondary details: tabs (desktop) / accordions (mobile) ===== */
  (function () {
    document.querySelectorAll('[data-disclosure]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-disc-item]'));
      if (!items.length) return;
      var headers = items.map(function (it) { return it.querySelector('[data-disc-header]'); });
      var panels = items.map(function (it) { return it.querySelector('[data-disc-panel]'); });
      var mq = window.matchMedia('(min-width: 768px)');
      var active = 0;

      function clearRoles() {
        root.removeAttribute('role');
        headers.forEach(function (h) {
          h.removeAttribute('role');
          h.removeAttribute('aria-selected');
          h.removeAttribute('aria-expanded');
          h.removeAttribute('tabindex');
        });
        panels.forEach(function (p) {
          p.removeAttribute('role');
          p.removeAttribute('tabindex');
        });
      }

      function render() {
        clearRoles();
        if (mq.matches) {
          /* Tabs: one panel visible, roving tabindex */
          root.setAttribute('role', 'tablist');
          headers.forEach(function (h, i) {
            h.setAttribute('role', 'tab');
            h.setAttribute('aria-selected', i === active ? 'true' : 'false');
            h.setAttribute('tabindex', i === active ? '0' : '-1');
            panels[i].setAttribute('role', 'tabpanel');
            panels[i].setAttribute('tabindex', '0');
            panels[i].hidden = i !== active;
          });
        } else {
          /* Accordion: independent toggles */
          headers.forEach(function (h, i) {
            h.setAttribute('aria-expanded', i === active ? 'true' : 'false');
            panels[i].hidden = i !== active;
          });
        }
      }

      headers.forEach(function (h, i) {
        h.addEventListener('click', function () {
          if (mq.matches) {
            active = i;
            render();
          } else {
            var open = panels[i].hidden;
            panels[i].hidden = !open;
            h.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (open) active = i;
          }
        });
        h.addEventListener('keydown', function (e) {
          if (!mq.matches) return;
          var n = headers.length, next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % n;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + n) % n;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = n - 1;
          if (next !== null) {
            e.preventDefault();
            active = next;
            render();
            headers[next].focus();
          }
        });
      });

      if (mq.addEventListener) mq.addEventListener('change', render);
      render();
    });
  })();

  /* ===== Sticky add-to-cart bar: reveal once the inline CTA scrolls above the viewport ===== */
  (function () {
    var inlineCta = document.querySelector('.product__cta');
    var stickyBar = document.getElementById('product-sticky-bar');
    if (!inlineCta || !stickyBar || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        /* Only show the sticky bar when the inline button has scrolled ABOVE
           the viewport (not while it's still below, before first scroll). */
        var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', scrolledPast);
      });
    }, { threshold: 0 });

    io.observe(inlineCta);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function() {
  'use strict';

  var section = document.querySelector('.search-page');
  if (!section) return;

  var grid = section.querySelector('[data-search-grid]');
  if (!grid) return;

  // Enable AJAX mode
  section.classList.add('search-page--ajax-active');

  var currentPage = parseInt(new URLSearchParams(window.location.search).get('page')) || 1;

  function getSectionId() {
    var wrapper = section.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : 'search';
  }

  function announce(message) {
    var statusEl = section.querySelector('[data-search-status]');
    if (statusEl) statusEl.textContent = message;
  }

  // Load more — event delegation
  section.addEventListener('click', function(e) {
    var loadMoreBtn = e.target.closest('.search-page__load-more-btn');
    if (!loadMoreBtn) return;

    var nextUrl = loadMoreBtn.getAttribute('data-next-url');
    if (!nextUrl) return;

    loadMoreBtn.disabled = true;
    loadMoreBtn.textContent = 'Loading...';

    var sectionId = getSectionId();
    var fetchUrl = nextUrl + (nextUrl.includes('?') ? '&' : '?') + 'sections=' + sectionId;

    fetch(fetchUrl)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var html = data[sectionId];
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Append new results to grid
        var newGrid = doc.querySelector('[data-search-grid]');
        var firstNewCard = null;
        if (newGrid) {
          var fragment = document.createDocumentFragment();
          Array.from(newGrid.children).forEach(function(child) {
            var clone = child.cloneNode(true);
            if (!firstNewCard) firstNewCard = clone;
            fragment.appendChild(clone);
          });
          grid.appendChild(fragment);
        }

        // Update load-more button
        var newLoadMore = doc.querySelector('[data-search-load-more]');
        var loadMoreContainer = section.querySelector('[data-search-load-more]');
        if (loadMoreContainer) {
          if (newLoadMore) {
            loadMoreContainer.innerHTML = newLoadMore.innerHTML;
          } else {
            loadMoreContainer.innerHTML = '';
          }
        }

        // Update pagination silently
        var newPagination = doc.querySelector('[data-search-pagination]');
        var paginationContainer = section.querySelector('[data-search-pagination]');
        if (paginationContainer && newPagination) {
          paginationContainer.innerHTML = newPagination.innerHTML;
        }

        // Update URL silently
        history.replaceState(null, '', nextUrl);
        currentPage++;

        var newCount = newGrid ? newGrid.children.length : 0;
        announce(newCount + ' more results loaded.');

        // Move keyboard focus to the first newly-loaded result (the old
        // load-more button was replaced, so focus would otherwise be lost).
        if (firstNewCard) {
          var focusTarget = firstNewCard.querySelector('a, button') || firstNewCard;
          if (focusTarget === firstNewCard) firstNewCard.setAttribute('tabindex', '-1');
          focusTarget.focus();
        }
      })
      .catch(function(err) {
        console.error('[Search Load More]', err);
        loadMoreBtn.disabled = false;
        loadMoreBtn.textContent = 'Load more';
        announce('Error loading more results. Please try again.');
      });
  });

  // Handle browser back/forward
  window.addEventListener('popstate', function() {
    window.location.reload();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-lookbook-hotspots"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.currentScript
      ? document.currentScript.closest('[data-section-id]')
      : null;

    const root = section || document;
    const pins = root.querySelectorAll('.lookbook__pin');
    const cards = root.querySelectorAll('.lookbook__product-card');

    if (!pins.length) return;

    function closeAllCards() {
      cards.forEach(function(card) {
        card.classList.remove('is-active');
      });
      pins.forEach(function(pin) {
        pin.setAttribute('aria-expanded', 'false');
      });
    }

    pins.forEach(function(pin) {
      pin.addEventListener('click', function(e) {
        e.stopPropagation();
        var cardId = pin.getAttribute('aria-controls');
        var card = document.getElementById(cardId);
        var isOpen = pin.getAttribute('aria-expanded') === 'true';

        closeAllCards();

        if (!isOpen && card) {
          var container = pin.closest('.lookbook__image-container');
          var pinRect = pin.getBoundingClientRect();
          var containerRect = container.getBoundingClientRect();

          var pinCenterX = pinRect.left - containerRect.left + pinRect.width / 2;
          var pinBottom = pinRect.bottom - containerRect.top;

          /* Flip horizontally if pin is in the right 60% of the container */
          if (pinCenterX > containerRect.width * 0.6) {
            card.style.left = 'auto';
            card.style.right = (containerRect.width - pinCenterX + 10) + 'px';
          } else {
            card.style.left = (pinCenterX + 10) + 'px';
            card.style.right = 'auto';
          }

          /* Flip vertically if pin is in the bottom 60% of the container */
          if (pinBottom > containerRect.height * 0.6) {
            card.style.top = 'auto';
            card.style.bottom = (containerRect.height - pinRect.top + containerRect.top + 10) + 'px';
          } else {
            card.style.top = pinBottom + 'px';
            card.style.bottom = 'auto';
          }

          card.classList.add('is-active');
          pin.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* Close on click outside */
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.lookbook__pin') && !e.target.closest('.lookbook__product-card')) {
        closeAllCards();
      }
    });

    /* Close on Escape and return focus to trigger pin */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var expandedPin = root.querySelector('.lookbook__pin[aria-expanded="true"]');
        closeAllCards();
        if (expandedPin) {
          expandedPin.focus();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
  /**
   * Wishlist Page — renders saved products from localStorage via the global
   * window.WishlistService (snippets/wishlist-service.liquid).
   *
   * Cards are built with DOM APIs + textContent (no innerHTML) so tampered
   * localStorage values can never inject markup.
   */
  (function WishlistPageInit() {
    'use strict';

    var SVG_NS = 'http://www.w3.org/2000/svg';
    var grid = document.querySelector('[data-wishlist-grid]');
    var emptyState = document.querySelector('[data-wishlist-empty]');
    var statusEl = document.querySelector('[data-wishlist-status]');

    if (!grid || !emptyState) return;

    function formatMoney(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      var amount = (cents / 100).toFixed(2);
      return 'R ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function clearGrid() {
      while (grid.firstChild) grid.removeChild(grid.firstChild);
    }

    function makeCloseIcon() {
      var svg = document.createElementNS(SVG_NS, 'svg');
      svg.setAttribute('width', '16');
      svg.setAttribute('height', '16');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true');
      var path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', 'M18 6 6 18M6 6l12 12');
      svg.appendChild(path);
      return svg;
    }

    function buildCard(item) {
      var card = document.createElement('div');
      card.className = 'wishlist-card';
      card.setAttribute('data-wishlist-card', '');
      card.setAttribute('data-product-id', item.id);

      var media = document.createElement('div');
      media.className = 'wishlist-card__media';

      if (item.image) {
        var mediaLink = document.createElement('a');
        mediaLink.href = item.url || '#';
        mediaLink.tabIndex = -1;
        mediaLink.setAttribute('aria-hidden', 'true');
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.className = 'wishlist-card__image';
        img.width = 600;
        img.height = 800;
        img.loading = 'lazy';
        mediaLink.appendChild(img);
        media.appendChild(mediaLink);
      }

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'wishlist-card__remove';
      removeBtn.setAttribute('data-wishlist-remove', item.id);
      removeBtn.setAttribute('aria-label', 'Remove ' + (item.title || 'item') + ' from wishlist');
      removeBtn.appendChild(makeCloseIcon());
      media.appendChild(removeBtn);

      var content = document.createElement('div');
      content.className = 'wishlist-card__content';

      var titleLink = document.createElement('a');
      titleLink.href = item.url || '#';
      titleLink.className = 'wishlist-card__title';
      titleLink.textContent = item.title || '';

      var price = document.createElement('span');
      price.className = 'wishlist-card__price';
      price.appendChild(document.createTextNode(formatMoney(item.price)));
      if (item.comparePrice && item.comparePrice > item.price) {
        var cmp = document.createElement('span');
        cmp.className = 'wishlist-card__compare-price';
        cmp.textContent = formatMoney(item.comparePrice);
        price.appendChild(cmp);
      }

      content.appendChild(titleLink);
      content.appendChild(price);

      card.appendChild(media);
      card.appendChild(content);
      return card;
    }

    function renderWishlist() {
      if (!window.WishlistService) {
        /* Wait for the global service to load */
        setTimeout(renderWishlist, 100);
        return;
      }

      var items = window.WishlistService.getAll();

      if (items.length === 0) {
        grid.hidden = true;
        emptyState.hidden = false;
        clearGrid();
        return;
      }

      grid.hidden = false;
      emptyState.hidden = true;
      clearGrid();
      items.forEach(function(item) {
        grid.appendChild(buildCard(item));
      });
    }

    function handleRemove(e) {
      var removeBtn = e.target.closest('[data-wishlist-remove]');
      if (!removeBtn) return;

      var productId = removeBtn.dataset.wishlistRemove;
      var card = removeBtn.closest('[data-wishlist-card]');

      function commit() {
        window.WishlistService.remove(productId);
        renderWishlist();
        if (statusEl) statusEl.textContent = 'Item removed from wishlist.';
      }

      if (card) {
        card.classList.add('wishlist-card--removing');
        card.addEventListener('transitionend', commit, { once: true });

        /* Fallback for prefers-reduced-motion (no transition fires) */
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          commit();
        }
      } else {
        commit();
      }
    }

    grid.addEventListener('click', handleRemove);
    renderWishlist();

    /* Re-render when the wishlist changes from other tabs/pages */
    document.addEventListener('wishlist:changed', renderWishlist);
  })();

  } catch(e) { console.error(e); }
})();
})();
